import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

/**
 * Bloc « réserver les deux gîtes ensemble » — version accueil / les-maisons
 */
export function GroupOffer() {
  return (
    <motion.section data-testid="group-offer" initial="hidden" whileInView="show" viewport={{ once: true }} variants={fadeUp}
      className="bg-stone/50 border-y border-sand">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20 lg:py-24 text-center">
        <h2 className="font-serif text-3xl lg:text-4xl font-light text-forest">Ensemble, jusqu'à 10 personnes</h2>
        <p className="text-charcoal/70 mt-6 text-lg leading-relaxed max-w-2xl mx-auto">
          Vous venez en famille ou entre amis ? Chez Anne et Au 19 peuvent être réservés ensemble pour accueillir jusqu'à 10 personnes, réparties dans deux gîtes indépendants, avec quatre chambres au total. La réservation des deux logements est soumise à leur disponibilité aux mêmes dates. Contactez Anne pour préparer votre séjour.
        </p>
        <Link to="/contact" className="inline-block mt-8">
          <Button data-testid="group-offer-cta" className="rounded-full bg-forest hover:bg-forest-dark text-cream px-8 h-12 text-base">
            Préparer un séjour à 10 <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </Link>
      </div>
    </motion.section>
  );
}

/**
 * Bloc « vous venez plus nombreux ? » — version page gîte individuelle
 */
export function GroupOfferHouse() {
  return (
    <motion.div data-testid="group-offer-house" initial="hidden" whileInView="show" viewport={{ once: true }} variants={fadeUp}
      className="mt-12 rounded-2xl bg-stone/50 border border-sand p-8">
      <h3 className="font-serif text-2xl text-forest">Vous venez plus nombreux ?</h3>
      <p className="text-charcoal/70 mt-4 leading-relaxed">
        Chez Anne et Au 19 peuvent être réservés ensemble pour accueillir jusqu'à 10 personnes dans deux logements indépendants, avec quatre chambres au total, sous réserve de disponibilités communes.
      </p>
      <Link to="/contact" className="inline-flex items-center gap-2 mt-5 text-forest font-medium hover:gap-3 transition-all">
        Contacter Anne pour les deux gîtes <ArrowRight className="w-4 h-4" />
      </Link>
    </motion.div>
  );
}

/**
 * Bloc « réserver les deux gîtes » — version page contact
 */
export function GroupOfferContact() {
  return (
    <div data-testid="group-offer-contact" className="mt-10 rounded-2xl bg-stone/50 border border-sand p-8">
      <h2 className="font-serif text-2xl text-forest">Réserver les deux gîtes</h2>
      <p className="text-charcoal/70 mt-4 leading-relaxed">
        Pour un séjour jusqu'à 10 personnes, indiquez à Anne vos dates et le nombre de voyageurs. Elle vérifiera la disponibilité simultanée de Chez Anne et d'Au 19 et vous précisera les conditions de réservation.
      </p>
    </div>
  );
}
